import type { NewsArticle } from './newsData';

export const newsArchive2025: NewsArticle[] = [
  {
    slug: 'spring-seminar-guidance-202503',
    date: '2025年3月8日',
    category: 'update',
    categoryLabel: '特集',
    title: '英国執事の作法と日本のおもてなしを授業でつなぐ設計',
    metaDescription:
      '英国執事の作法と日本のおもてなしを、どのように同じ授業のなかで接続しているかを解説します。型の由来を整理したうえで、お台場本校の実技で双方の考え方を往復させる進め方と、定員6名の少人数制が果たす役割を具体的に紹介します。',
    keywords: ['英国執事', 'おもてなし', '作法', '接遇教育', '実技授業', 'お台場本校'],
    heroImage: '/images/generated/training-basic-2026.jpg',
    heroAlt: '立ち居振る舞いの基本を確認する実技授業の様子',
    figures: [
      {
        src: '/images/generated/essential-manners-2026.jpg',
        alt: 'テーブルまわりの所作を手元で確かめる演習風景',
        caption: '由来の異なる作法を、同じ場面設定で比較しながら身につけます',
      },
    ],
    overview: {
      heading: '授業設計の要点',
      rows: [
        { label: '主題', value: '英国作法と日本のおもてなしの接続' },
        { label: '実施形態', value: '土日開催／1日6時間（90分×4コマ）' },
        { label: '定員', value: '6名（最少催行3名）' },
        { label: '教材', value: '教科書全15冊のうち該当章を重点使用' },
        { label: '会場', value: 'お台場本校' },
      ],
    },
    faq: [
      {
        question: '英国流と日本流のどちらを優先して教えますか？',
        answer:
          '優先順位を固定せず、場面ごとに求められる判断基準を先に共有します。由来を区別したうえで、どちらを選ぶかを自分で説明できる状態を目指します。',
      },
      {
        question: '未経験でも二つの作法を同時に学べますか？',
        answer:
          'はい。最初は共通する「間の取り方」と視線の扱いから入り、その後に英国由来の型と日本のおもてなしの表現を分けて演習します。',
      },
      {
        question: '座学と実技の比率はどの程度ですか？',
        answer:
          '1日6時間（90分×4コマ）のうち、考え方の整理に1コマ、残りの時間を実技と振り返りに充てる配分を基本としています。',
      },
    ],
    related: [
      { title: 'カリキュラム', desc: '授業の組み立てと進行', href: '/curriculum' },
      { title: 'コース一覧', desc: '3コースそれぞれの到達点', href: '/courses' },
      { title: '教材紹介', desc: '全15冊の使い方', href: '/materials' },
      { title: '説明会・体験講座', desc: '授業の空気感を先に確認', href: '/seminar' },
      { title: '資料請求（無料）', desc: '学び方の概要をまとめて送付', href: '/brochure' },
    ],
    body: `<p>英国の屋敷で培われた執事の作法と、日本のおもてなしは、見た目の優雅さでは重なる部分があります。しかし授業では、似ているからこそ混同しやすい点を先に切り分けます。日本執事アカデミーでは、型を真似る前に「何のための動作か」を言葉にし、そのうえで双方を接続する設計を採っています。</p>
<h2>由来を分けてから重ねる</h2>
<p>英国側では、主人の時間と空間を守るための距離感、静かな移動、声量の抑え方が中核になります。日本側では、相手の立場を先回りして整える気配り、季節や場の空気に合わせた言葉選びが前面に出ます。同じ「お迎え」でも、玄関での位置取り一つで意図が変わるため、講義ではまず短い映像と図解で由来を示し、直後に実技へ移ります。</p>
<h2>90分×4コマで往復する進め方</h2>
<p>土日開催の1日6時間は、座学だけで終わらせません。初回コマで用語と歴史的背景を整理し、続く2コマでお台場本校の実習空間を使い、英国流の案内動線と日本流の座敷・応接の所作を交互に試します。最終コマでは、受講者同士が観察メモを交換し、どこが文化の差で、どこが個人の癖かを仕分けます。定員6名・最少催行3名の少人数だからこそ、一人ずつ動作を止めて確認できます。</p>
<h2>現場で迷わないための判断軸</h2>
<p>卒業後に直面するのは、教科書どおりの屋敷ばかりではありません。海外の来客を日本家屋で迎える、和装の行事に欧米式の配膳が混ざる、といった複合場面が増えています。授業では「主賓は誰か」「場の格式はどちらの文化を基調とするか」「静けさと温かさのどちらを優先するか」という三つの問いを毎回の演習に組み込み、選択理由を短く述べる訓練を重ねます。協会認定資格の修了実技試験でも、型の正確さに加え、判断の説明ができるかを見ます。二つの作法を対立させず、状況に応じて橋を架ける力が、本校が育てたい実務の核です。</p>`,
  },
  {
    slug: 'three-courses-autumn-opening-202507',
    date: '2025年7月12日',
    category: 'schedule',
    categoryLabel: 'カリキュラム',
    title: '邸宅運営を学ぶ意味——ハウスキーピングと資産管理の射程',
    metaDescription:
      'ハウスキーピングから資産管理まで、邸宅運営を学ぶ意味と授業で扱う範囲を整理しました。日常の維持管理と中長期の保全判断をどう往復させるか、アドバンス以上で深める視点と、少人数制での演習の進め方を具体的に示します。',
    keywords: ['邸宅運営', 'ハウスキーピング', '資産管理', '家政', 'アドバンスコース', 'マスターコース'],
    heroImage: '/images/generated/facilities-hero-2026.jpg',
    heroAlt: '整った邸内を想定して準備された本校の実習空間',
    figures: [
      {
        src: '/images/generated/about-classroom-2026.jpg',
        alt: '邸宅運営の手順をホワイトボードと実物で確認する教室',
        caption: '点検・記録・報告の一連を、教室でも再現できるよう配置しています',
      },
    ],
    overview: {
      heading: '邸宅運営モジュールの扱い',
      rows: [
        { label: '主な対象コース', value: 'アドバンス／マスター（基礎はエッセンシャルでも導入）' },
        { label: '扱う領域', value: 'ハウスキーピング／保全記録／資産管理の基礎' },
        { label: '授業形態', value: '土日・1日6時間（90分×4コマ）' },
        { label: '定員', value: '各コース6名（最少催行3名）' },
        { label: '評価', value: '修了実技試験に運営判断の課題を含む' },
      ],
    },
    faq: [
      {
        question: 'ハウスキーピングは掃除の技術だけを指しますか？',
        answer:
          'いいえ。清掃手順に加え、優先順位の付け方、委託先との境界、異常の早期発見と記録までを含めて扱います。',
      },
      {
        question: '資産管理は専門職向けの内容ですか？',
        answer:
          '会計の専門資格を目指す講座ではありません。備品・美術品・設備の台帳整備や更新判断など、邸宅側で必要な基礎判断に範囲を限定しています。',
      },
      {
        question: 'エッセンシャルだけでも触れられますか？',
        answer:
          '導入として点検リストの読み方と報告の型を扱います。深いケーススタディはアドバンス以降で行います。',
      },
    ],
    related: [
      { title: 'コース一覧', desc: 'アドバンスとマスターの違い', href: '/courses' },
      { title: 'カリキュラム', desc: '運営系科目の位置づけ', href: '/curriculum' },
      { title: '修了・認定について', desc: '実技試験で見る観点', href: '/certificate' },
      { title: '受講料金', desc: 'コース別の費用', href: '/pricing' },
      { title: '入学案内', desc: '申込条件と流れ', href: '/admission' },
    ],
    body: `<p>執事の仕事を「接客の洗練」だけで捉えると、邸宅そのものを守り続ける側面が見えにくくなります。日本執事アカデミーが邸宅運営をカリキュラムに置く理由は、日々の快適さと、建物・什器・記録といった資産の寿命を、同じ担当者がつなぐ必要があるからです。見えにくい維持管理こそ、信頼の基盤になります。</p>
<h2>ハウスキーピングが担う範囲</h2>
<p>授業でいうハウスキーピングは、表面を美しく保つ作業に止まりません。ゾーンごとの清掃頻度、使用薬剤の選定、季節による湿気対策、来客前後の点検順序までを一連の手順として設計します。教科書全15冊のうち該当巻では、チェックリストの書き方と、異常を発見したときの報告文例を併記しています。定員6名の演習では、実際に部屋を回り、抜け漏れを互いに指摘し合う時間を確保します。</p>
<h2>資産管理をどこまで扱うか</h2>
<p>資産管理と聞くと財務の高度な話を想像しがちですが、本校が扱うのは邸内で完結する基礎です。家具・食器・リネン・設備の台帳、購入日と修繕履歴、保険連絡先の整理、更新時期の目安づくりが中心です。金額の最終決定は所有者の領域だと明確に分けたうえで、現場から上げる提案書の骨格を作成します。マスターコースでは、複数棟や別宅がある想定のケースも用い、優先投資の説明練習を行います。</p>
<h2>接遇と運営を分断しない意味</h2>
<p>美しい案内ができても、空調の不具合や在庫切れが続けば体験の質は落ちます。逆に管理だけが厳格でも、人への温度がなければ屋敷の空気は固くなります。土日の1日6時間授業では、午前に接遇、午後に運営記録といった組み合わせを意図的に入れ、両方の感覚を同日に往復させます。修了実技試験でも、来客対応の直後に「本日見つかった不具合をどう記録し、誰へどの順で伝えるか」を口頭で問う課題を用意しています。出席率80％以上を前提に積み上げた反復が、現場での冷静な判断につながります。</p>`,
  },
  {
    slug: 'materials-curriculum-update-202511',
    date: '2025年11月15日',
    category: 'update',
    categoryLabel: '進学・編入',
    title: '学びを重ねる人のためのコース間の進み方と編入優遇',
    metaDescription:
      'エッセンシャルからアドバンス、マスターへと学びを続ける方向けに、コース間の進み方と編入優遇の考え方を説明します。既修内容の扱い、再試験との関係、個別相談で確認する点など、次の一歩を検討する際の判断材料をまとめました。',
    keywords: ['編入', 'コース進学', 'エッセンシャル', 'アドバンス', 'マスター', '継続学習'],
    heroImage: '/images/generated/about-hero-2026.jpg',
    heroAlt: '次の課程を検討する受講者向けに整えた相談スペース',
    figures: [
      {
        src: '/images/generated/essential-writing-2026.jpg',
        alt: '既修内容をノートに整理しながら進路面談に備える様子',
        caption: '既に身につけた範囲を可視化してから、編入後の科目配置を決めます',
      },
    ],
    overview: {
      heading: 'コース間進学の枠組み',
      rows: [
        { label: '対象', value: '既修了者および上位コース希望者' },
        { label: 'コース構成', value: 'エッセンシャル／アドバンス／マスター' },
        { label: '優遇の考え方', value: '既修単位相当の読み替えと課題の個別調整' },
        { label: '定員', value: '各コース6名（最少催行3名）' },
        { label: '相談窓口', value: 'お台場本校／入学相談' },
      ],
    },
    faq: [
      {
        question: '下位コースを修了していれば自動的に編入できますか？',
        answer:
          '自動ではありません。修了実技試験の結果と出席状況を確認し、上位コースの到達目標に対する不足領域がある場合は補講課題を設定します。',
      },
      {
        question: '編入優遇で受講料はどのように扱われますか？',
        answer:
          '既に修了した範囲に相当する科目の重複受講を避ける方向で調整します。具体額は個別に試算し、入学案内と料金ページの条件に沿って提示します。',
      },
      {
        question: '再試験を受けた場合でも進学は可能ですか？',
        answer:
          '可能です。再試験は1回無料です。合格後に進学相談へ進んでいただければ、編入時点の課題設定に反映します。',
      },
    ],
    related: [
      { title: '入学案内', desc: '編入相談の申し込み手順', href: '/admission' },
      { title: 'コース一覧', desc: '3コースの到達目標比較', href: '/courses' },
      { title: '受講料金', desc: '費用と調整の前提', href: '/pricing' },
      { title: '修了・認定について', desc: '試験と資格の関係', href: '/certificate' },
      { title: 'お問い合わせ', desc: '進路面談の予約', href: '/contact' },
    ],
    body: `<p>一つのコースで得た型を、次の段階でどう拡張するか。継続して学ぶ方から最も多い質問が、コース間の進み方です。日本執事アカデミーでは、エッセンシャル・アドバンス・マスターを単なる難易度の階段ではなく、役割の広がりとして設計しています。編入優遇も「割引ありき」ではなく、既に身につけた能力を重複させないための仕組みです。</p>
<h2>三つのコースが担うレイヤー</h2>
<p>エッセンシャルは、立ち居振る舞いと基本接遇など、個人の動作精度を固める層です。アドバンスは、複数人が動く場面での指示受けとサービス設計、テーブルまわりの応用を広げます。マスターは、邸宅全体の運営判断や長期の備えまで視野に入れます。下位で培った筋肉記憶を捨てるのではなく、判断の半径を広げていくイメージです。</p>
<h2>編入優遇で見ているもの</h2>
<p>優遇の可否は、修了実技試験の評価表、出席率80％以上の充足、提出課題の質を材料に判断します。合格ラインを超えていても、上位コースで必須となる領域に空白があれば、短期の補完課題を課します。逆に十分なら、重複する座学コマを読み替え、実技の高度課題へ時間を振り向けます。再試験を経た方についても、1回無料の再挑戦で合格していれば、その後の編入審査で不利にはしません。</p>
<h2>進学を急がない選択も尊重する</h2>
<p>すべての修了者に、すぐ次のコースへ進むことを勧めるわけではありません。現場で半年から一年ほど実践し、課題が明確になってからアドバンスへ進む方のほうが、吸収が速い例も少なくありません。お台場本校での進路面談では、勤務形態や学びたい場面（接遇中心か、運営中心か）を聞き取り、最短距離だけを良しとしない提案を行います。定員6名・最少催行3名という規模は、編入者一人の課題セットを個別に組む余地でもあります。次の一歩を検討中の方は、資料請求や個別の問い合わせから、現在地の棚卸しを始めてみてください。焦らず精度を上げる進み方こそ、長く使える作法につながります。</p>`,
  },
  {
    slug: 'advance-applied-protocol-202504',
    date: '2025年4月10日',
    category: 'schedule',
    categoryLabel: '開校情報',
    title: '4月開校のアドバンス——応用接遇と国際儀礼に踏み込む12日間',
    metaDescription:
      '2025年4月にお台場本校でアドバンスコースを開校します。2ヶ月12日間72時間の土日制で、応用接遇と国際儀礼を実技中心に扱います。定員6名・最少催行3名、修了実技試験と申込手順、向いている方の目安をまとめました。',
    keywords: ['アドバンスコース', '開校', '国際儀礼', '応用接遇', '2025年4月', 'お台場本校'],
    heroImage: '/images/generated/training-service-2026.jpg',
    heroAlt: '国際儀礼を想定した案内動線を確認するアドバンスの実技',
    figures: [
      {
        src: '/images/generated/table-protocol-2026.jpg',
        alt: '席次と紹介の順序をテーブル上で検証する演習',
        caption: '格式の異なる来客が並ぶ想定で、順序と距離感をその場で調整します',
      },
    ],
    overview: {
      heading: '2025年4月アドバンス開校の概要',
      rows: [
        { label: '対象コース', value: 'アドバンス（2ヶ月・12日間・72時間）' },
        { label: '開校時期', value: '2025年4月（土日開催）' },
        { label: '1日の構成', value: '6時間（90分×4コマ）' },
        { label: '定員', value: '6名（最少催行3名）' },
        { label: '会場', value: 'お台場本校' },
      ],
    },
    faq: [
      {
        question: 'エッセンシャル未修了でも申し込めますか？',
        answer:
          '基礎動作の確認面談で同等の準備があると判断できた場合に受け付けます。不足が大きい場合は、先にエッセンシャルの受講を案内します。',
      },
      {
        question: '国際儀礼は座学が中心ですか？',
        answer:
          '枠組みの整理は座学で行いますが、直後に実習室で席次・紹介・贈り物の受け渡しを身体で確認する配分です。',
      },
      {
        question: '修了実技試験に不合格だった場合は？',
        answer:
          '再試験を1回無料で受けられます。出席率80％以上が受験条件となる点だけ、事前にスケジュールを確認してください。',
      },
    ],
    related: [
      { title: 'コース一覧', desc: 'アドバンスの到達目標', href: '/courses' },
      { title: 'カリキュラム', desc: '応用科目の並び', href: '/curriculum' },
      { title: '入学案内', desc: '面談と提出書類', href: '/admission' },
      { title: '受講料金', desc: '費用の内訳', href: '/pricing' },
      { title: '修了・認定について', desc: '実技試験の観点', href: '/certificate' },
    ],
    body: `<p>2025年4月、お台場本校でアドバンスコースを開校します。エッセンシャルで固めた基本動作を前提に、応用接遇と国際儀礼へ踏み出す回です。国籍や格式の異なる来客が同じ空間にいる場面でも、主人の意向を損ねず動ける判断を、土日の実技のなかで積み上げます。</p>
<h2>日程・時間・扱う範囲</h2>
<p>期間は2ヶ月、登校は12日間、総時間は72時間です。1日6時間（90分×4コマ）を基本とし、初回コマで国際儀礼の枠と用語を整理したあと、残りのコマで案内動線・紹介の順序・多言語が交じる場での声量を反復します。教科書全15冊のうち応用章を重点的に使い、テーブルまわりでは献杯や席次の選択理由を短く言語化する練習を入れます。協会認定資格に向けた修了実技試験では、型の精度に加え、状況説明の明瞭さも確認します。</p>
<h2>定員と向いている方</h2>
<p>定員6名・最少催行3名の少人数制です。一人の動作を止めて視線の高さや立ち位置をその場で直せる密度を優先しています。主な対象は、エッセンシャル修了相当の基礎がある方、または現場で接遇を担当し応用の型を整理したい方です。春から初夏にかけて来客の属性が変わりやすい時期に合わせ、複合的な場面設定を多めに配置しています。</p>
<h2>申込から開講までの手順</h2>
<p>入学案内ページから希望開始月と志望理由を送付してください。書類確認の後、お台場本校または遠隔で面談を行い、到達目標と欠席時の補完方法をすり合わせます。定員に達した時点で当該回の受付を終了します。料金は受講料金ページ、科目の順序はカリキュラムページで事前に照合できます。四月開校分は準備期間が限られるため、面談枠の確保を急ぐほど選択肢が広がります。国際儀礼を「知識」で終わらせず、その場の空気に落とす訓練を求める方の参加を待ちます。</p>`,
  },
  {
    slug: 'essential-advance-parallel-202509',
    date: '2025年9月8日',
    category: 'recruitment',
    categoryLabel: '募集情報',
    title: '9月は二課程並行——エッセンシャルとアドバンスを同学期に開講',
    metaDescription:
      '2025年9月、エッセンシャルとアドバンスを同学期に並行開講します。1ヶ月48時間と2ヶ月72時間の土日制を時間帯で分け、定員は各6名。資料請求から志望コース申告、面談までの流れと学び方の違いを具体的に案内します。',
    keywords: ['エッセンシャル', 'アドバンス', '並行開講', '募集', '2025年9月', '土日開講'],
    heroImage: '/images/generated/courses-parallel-2026.jpg',
    heroAlt: '基礎課程と応用課程の時間割を並べて確認する様子',
    figures: [
      {
        src: '/images/generated/classroom-weekend-2026.jpg',
        alt: '土日に分かれて進む二課程の教室準備',
        caption: '共用の実習空間を、コース別に時間をずらして運用します',
      },
    ],
    overview: {
      heading: '2025年9月・二課程並行開講',
      rows: [
        { label: '開講コース', value: 'エッセンシャル／アドバンス（同時期）' },
        { label: 'エッセンシャル', value: '1ヶ月・8日間・48時間' },
        { label: 'アドバンス', value: '2ヶ月・12日間・72時間' },
        { label: '定員', value: '各コース6名（最少催行3名）' },
        { label: '開催', value: '土日・お台場本校' },
      ],
    },
    faq: [
      {
        question: '同じ日に両コースを受講できますか？',
        answer:
          'できません。進度と実習室の割り当てが異なるため、いずれか一方を選んで申し込んでください。',
      },
      {
        question: 'どちらを選ぶか迷う場合の手がかりは？',
        answer:
          '動作の基礎を一から固めたい方はエッセンシャル、複数人が動く場面の設計や国際儀礼の応用を求める方はアドバンスが適します。',
      },
      {
        question: '募集はいつ締め切られますか？',
        answer:
          '各コースとも定員6名に達した時点で締め切ります。最少催行3名に満たない場合は開講を見送る可能性があります。',
      },
    ],
    related: [
      { title: '資料請求（無料）', desc: '二課程の比較表を送付', href: '/brochure' },
      { title: 'コース一覧', desc: '時間数と到達点の差', href: '/courses' },
      { title: '入学案内', desc: '志望コースの申告方法', href: '/admission' },
      { title: '説明会・体験講座', desc: '教室の空気を先に体験', href: '/seminar' },
      { title: 'アクセス', desc: 'お台場本校への行き方', href: '/access' },
    ],
    body: `<p>2025年9月、エッセンシャルコースとアドバンスコースを同じ学期に並行して開講します。基礎を一から固める方と、応用へ進む方が同じ校舎で学ぶ回です。進度自体はコースごとに分け、共用の実習空間は曜日と時間帯をずらして運用し、それぞれの到達点を守りながら進めます。</p>
<h2>二つの時間設計</h2>
<p>エッセンシャルは1ヶ月・8日間・48時間。立ち居振る舞い、基本の案内、言葉遣いなど、個人の動作精度を集中して高めます。アドバンスは2ヶ月・12日間・72時間。指示の受け方、サービス設計、国際儀礼を含む応用場面を扱います。どちらも土日開催、1日6時間（90分×4コマ）です。教科書全15冊はコースに応じた章から入り、修了時には協会認定資格に対応する実技試験を実施します。出席率80％以上が受験の前提で、再試験は1回無料です。</p>
<h2>定員・会場・向く選択</h2>
<p>定員は各コース6名、最少催行は3名です。お台場本校のみでの開講となります。初めて体系的に学ぶ方、動作の癖をリセットしたい方はエッセンシャルが適合しやすいです。すでに基礎があり、複数人が同時に動く場での判断や席次の調整を鍛えたい方はアドバンスを選んでください。並行開講でも教室は混在させず、評価基準もコース別のままです。</p>
<h2>募集の入り方</h2>
<p>今回はまず資料請求で二課程の比較表を受け取り、続けて入学案内から志望コースを一つ申告する流れを推奨します。その後に面談で、欠席時の補完や教材の準備状況を確認し、席を確定します。説明会・体験講座に参加してから決めることもできます。各コースとも定員に達し次第締め切り、最少人数に届かない場合は開講を見送ることがあります。秋学期からリズムを作りたい方は、比較表の確認と面談予約を早めに進めてください。自分の現在地に合う一方の課程を選び、深い反復に時間を使う学期にしましょう。</p>`,
  },
];
